"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("@mulesoft/exchange-ui-portals-store/lib/domains/pages/utils");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var styles = {
  "minor-version-pill": "UnderlyingAPITermsList__minor-version-pill__248W7",
  "minorVersionPill": "UnderlyingAPITermsList__minor-version-pill__248W7",
  "underlying-api-name": "UnderlyingAPITermsList__underlying-api-name__39sLR",
  "underlyingApiName": "UnderlyingAPITermsList__underlying-api-name__39sLR"
}; 
require('./UnderlyingAPITermsList.css');
var UnderlyingAPITermsList = function UnderlyingAPITermsList(props) {
  var underlyingAPIsTerms = props.underlyingAPIsTerms;
  var config = (0, _exchangeReactHooks.useConfig)();
  if (underlyingAPIsTerms.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, underlyingAPIsTerms.map(function (_ref, index) {
    var termsText = _ref.termsText,
      name = _ref.name,
      groupId = _ref.groupId,
      assetId = _ref.assetId,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '' : _ref$version,
      minorVersion = _ref.minorVersion;
    return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.CollapsibleCard, {
      key: "".concat(groupId, ".").concat(assetId, ".").concat(minorVersion),
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.underlyingApiName
      }, name), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.minorVersionPill
      }, minorVersion, ".x")),
      testId: "".concat(index, "-").concat(minorVersion, "-terms")
    }, /*#__PURE__*/_react.default.createElement("div", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: (0, _utils.markdownToHTML)({
          markdown: termsText,
          options: {
            minHeaderLevel: 3
          },
          config: config,
          groupId: groupId,
          assetId: assetId,
          version: version
        })
      }
    }));
  }));
};
var _default = exports.default = UnderlyingAPITermsList;
//# sourceMappingURL=UnderlyingAPITermsList.js.map